var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger hamburger--slider flex items-center",attrs:{"type":"button"}},[_c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner",style:(("--variant: " + _vm.color + ";"))})])])}
var staticRenderFns = []

export { render, staticRenderFns }